import { Component, OnInit }          from '@angular/core';
import { ActivatedRoute }             from '@angular/router';

import { UserService }                from '../dashboard/program-list/user.service';
import { CurrentUserService }         from '../shared/services/current-user.service';
import { SubscriptionsService }       from './subscriptions.service';
import { SubscriptionUser }           from './models/subscription-user';
import { User }                       from '../models/program/user';

import { PermissionsService }         from '../shared/services/permissions.service';
import { AllPermissions }             from '../models/permissions';

@Component({
  selector: 'app-subscription-users',
  templateUrl: './subscription-users.component.html',
  styleUrls: ['./subscription-users.component.less']
})
export class SubscriptionUsersComponent implements OnInit {
  private _subscriptionId: number = null;
  public users: SubscriptionUser[] = null;
  public checkedUsers: number[] = [];
  public selectedUser: SubscriptionUser = null;
  public userSettings: User = null;
  public userAnalytics: boolean = false;
  public showRemoveUser: boolean = false;
  public showNewUsers: boolean = false;
  public newUsers: any[] = [];
  public addingNewUsers: boolean = false;
  public permissions: AllPermissions;
  public currentUserId: number;


  constructor(private api: SubscriptionsService,
              private route: ActivatedRoute,
              private currentUserService: CurrentUserService,
              private userService: UserService,
              private permissionsService: PermissionsService) {
    this.route.parent.params.subscribe(params => {
      this._subscriptionId = params['id'];
      this.loadData();
    });
    permissionsService.retrievePermissions().subscribe(permissions => {
      this.permissions = permissions;
    });
    this.currentUserService.getUserData().subscribe(userData => {
      this.currentUserId = userData.sub;
    });

  }

  private loadData() {
    this.users = null;
    this.api.getSubscriptionUsers(this._subscriptionId).subscribe(users => this.users = users);
  }

  ngOnInit() {
  }

  public setUserAdmin(user, state): void {
    this.api.setUserAdmin(this._subscriptionId, user.id, state).subscribe(() => user.is_admin = state);
  }

  public setUserActive(user, state): void {
    this.api.setUserActive(this._subscriptionId, user.id, state).subscribe(() => user.active = state);
  }

  public setUserBuyer(user, state): void {
    let buyer_id = state ? user.user.id : null;

    this.api.updateSubscription(this._subscriptionId, {buyer_id}).subscribe(() => {
      this.users.forEach(u => {
        u.is_buyer = !!(buyer_id && u.user.id == buyer_id);
      });
    });
  }

  public openUserSettings(id: number): void {
      this.userService.getUser(id)
                      .subscribe(u => this.userSettings = u);
  }

  public linkUserToInvitation(event, userId: number, invitationId: number): void {
    event.preventDefault();
    this.api.linkUserToInvitation(userId, invitationId, this._subscriptionId).subscribe(() => this.loadData());
  }

  public openRemoveUser(user: SubscriptionUser) {
    this.selectedUser = user;
    this.showRemoveUser = true;
  }

  public removeSelectedUser() {
    this.api.removeInvitation(this.selectedUser.id, this._subscriptionId).subscribe(() => {
      this.users.splice(this.users.indexOf(this.selectedUser), 1);
      this.showRemoveUser = false;
    });
  }

  public handleNewUsers(users) {
    this.newUsers = users;
  }

  public addNewUsers() {
    this.addingNewUsers = true;
    this.api.addUsersToSubscription(this._subscriptionId, this.newUsers.map(u => ({id: u.id, email: u.email}))).subscribe(() => {
      this.addingNewUsers = false;
      this.newUsers = [];
      this.showNewUsers = false;
      this.loadData();
    });
  }

  get canSetUserAdmin(): boolean {
    return this.permissions.editionAdministration || this.permissions.nomadicAdministration
      || this.permissions.editionAnalytics;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscription-users.component.ts